<div class="toolchain-installation-container">
  <h1>Toolchain installation assistant</h1>
  <p>
    Upload the toolchain you wish to add to Hephaestus. To update an existing toolchain, upload the
    new version here as well. Please ensure that you increment the version number when submitting an
    update. The toolchain specification should be given as a *-toolchain.json.
  </p>
  <div class="content-container">
    @if (isUploadSuccessful()) {
      <mat-icon color="primary">download_done</mat-icon>
    } @else {
      <app-file-upload
        class="upload-field"
        (fileSelectedEvent)="onFileSelect($event)"
        [inputDetails]="{
          displayName: 'Toolchain',
          description: 'Upload here the toolchain specification file',
        }"
        [isList]="false"
        [supportedMediaTypes]="['application/json']">
      </app-file-upload>
    }
  </div>
  @if (!isUploadSuccessful() && isUploadStarted()) {
    <mat-error>
      Something went wrong while toolchain upload. See logs for further details.
    </mat-error>
  }
  @if (isUploadSuccessful() && isUploadStarted()) {
    <p>
      The tool was successfully uploaded. Installation will now begin. For more details, check the
      specific tool's settings.
    </p>
  }
  <div class="action-buttons">
    <button
      mat-raised-button
      (click)="installToolchain()"
      [disabled]="!selectedFile()"
      color="primary">
      Start installation
    </button>
    <button mat-raised-button (click)="openLogs()" [disabled]="!logs()" color="secondary">
      Show logs
    </button>
  </div>
</div>
<app-spinner></app-spinner>
